import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import { constant } from '../../../Utils/constants';
import {
  Form,
  DatePicker,
  TimePicker,
  Button
} from 'antd';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

// import {
//   getDeviceList,
//   getOrganisationsList,
//   getSitesList,
//   submitJobPlan,
//   getJobPlanById
// } from '../../../Utils/FormCalls';

const SchedulingWorkOrder = (props) => {
  // const [deviceList, setDeviceList] = useState([]);
  // const [organisationsList, setOrganisationsList] = useState([]);
  // const [sitesList, setSitesList] = useState([]);
  // const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  const taskRef = useRef();
  const schedulingWorkOrderRef = useRef();

  // useEffect(() => {
  // const fetchData = async () => {
  //     try {
  //       const deviceResponse = await getDeviceList();
  //       setDeviceList(deviceResponse.data);
  //     } catch (error) {
  //       message.warning(`${error.message}`);
  //     }
  //     try {
  //       const organisationsResponse = await getOrganisationsList();
  //       setOrganisationsList(organisationsResponse.data);
  //     } catch (error) {
  //       message.warning(`${error.message}`);
  //     }
  //     try {
  //       const sitesResponse = await getSitesList();
  //       setSitesList(sitesResponse.data);
  //     } catch (error) {
  //       message.warning(`${error.message}`);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      schedulingWorkOrderRef.current.setFieldsValue(props.formObject);
      taskRef.current.setFieldsValue(props.formObject.TaskData);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
      // setRecordData(props.formObject?.TaskData || []);
    }
  }, [props, formObject, translationCache]);

  const handleChange = (value, key) => {
    const updatedFormObject = {
      ...formObject,
      [key]: value
    };
    schedulingWorkOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  // const onFinish = async (values) => {
  //   const payload = {
  //     ...formObject,
  //     ...values
  //   };
  //   const statusResponse = await submitJobPlan(payload);

  //   if (statusResponse?.message) {
  //     props._getAdhocDataSource();
  //     message.success(statusResponse.message);
  //     onReset();
  //   } else if (statusResponse?.Error) {
  //     message.error(statusResponse.Error);
  //   }
  // };

  const onReset = () => {
    taskRef.current.resetFields();
    schedulingWorkOrderRef.current.resetFields();
  };

  // const jobPlanOnChange = async (value) => {
  //   const formObject = await getJobPlanById(value);
  //   const recordData = formObject.TaskData;
  //   setFormObject(formObject);
  //   setRecordData(recordData);
  // };

  return (
    <>
      <Form
        onFinish={(values) => props.onFinish(values, 'SchedulingWorkOrder')}
        name={'SchedulingWorkOrder'}
        ref={schedulingWorkOrderRef}
        className="jobplan"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation(translationCache, constant.targetStart)}
            name="TargetStart"
            onChange={(value) => handleChange(value, 'TargetStart')}
            rules={[{ required: false, message: 'Please Input TargetStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.targetFinish)}
            name="TargetFinish"
            onChange={(value) => handleChange(value, 'TargetFinish')}
            rules={[{ required: false, message: 'Please Input TargetFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.actualStart)}
            name="ActualStart"
            onChange={(value) => handleChange(value, 'ActualStart')}
            rules={[{ required: false, message: 'Please Input ActualStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.actualFinish)}
            name="ActualFinish"
            onChange={(value) => handleChange(value, 'ActualFinish')}
            rules={[{ required: false, message: 'Please Input ActualFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.schedulingStart)}
            name="SchedulingStart"
            onChange={(value) => handleChange(value, 'SchedulingStart')}
            rules={[{ required: false, message: 'Please Input SchedulingStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.schedulingFinish)}
            name="SchedulingFinish"
            onChange={(value) => handleChange(value, 'SchedulingFinish')}
            rules={[{ required: false, message: 'Please Input SchedulingFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.duration)}
            name="Duration"
            onChange={(value) => handleChange(value, 'Duration')}
            rules={[{ required: false, message: 'Please Input Duration!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <TimePicker
              placeholder={translation(translationCache, constant.selecttime)}
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.sequence)}
            name="subSequence"
            onChange={(e) => handleChange(e.target.value, 'Sequence')}
            rules={[{ required: false, message: 'Please Provide Sequence' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, 'Sequence')}
              style={{ width: '70%' }}
            />
          </Form.Item>
        </div>

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.save)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(SchedulingWorkOrder);